import { meetingBodyJoinDimensions } from './shared-dimensions.js';
import { seatTermApplicationStatusValueLabels } from './value-labels.js';
/**
 * Combination data source: Applicants x Applications x Meeting Bodies.
 * Shows which applicants have applied to which meeting bodies, with contact details,
 * qualifications, and application history metrics.
 */
export const bodyApplicantsCube = {
    category: 'Applications',
    description: 'Applicants linked to meeting bodies with contact details, qualifications, and application history.',
    label: 'Applicants by Meeting Body',
    requiredModule: 'hasTenure',
    measures: {
        'body_applicants.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        // Application
        'body_applicants.status': {
            label: 'Application Status',
            type: 'string',
            valueLabels: seatTermApplicationStatusValueLabels,
        },
        // Applicant
        'seat_applications.email': { label: 'Applicant Email', type: 'string' },
        'seat_applications.first_name': { label: 'Applicant First Name', type: 'string' },
        'seat_applications.last_name': { label: 'Applicant Last Name', type: 'string' },
        'seat_applications.qualifications': { label: 'Qualifications', type: 'string' },
        'seat_applications.reason': { label: 'Reason', type: 'string' },
        'seat_applications.total_applications': { label: 'Total Applications', type: 'number' },
        // Applicant contact
        'phones.number': { label: 'Applicant Phone Number', type: 'string' },
        ...meetingBodyJoinDimensions,
        // Seat
        'meeting_body_seats.title': { label: 'Seat Title', type: 'string' },
        // Term
        'meeting_body_seat_terms.is_current': { label: 'Term Is Current', type: 'boolean' },
    },
    timeDimensions: {
        'body_applicants.created_at': { label: 'Application Created At', type: 'date' },
        'seat_applications.first_applied_date': { label: 'First Applied Date', type: 'date' },
        'seat_applications.most_recent_application_date': {
            label: 'Most Recent Application Date',
            type: 'date',
        },
        'seat_applications.submitted_at': { label: 'Submitted At', type: 'date' },
    },
};
